.bl{right:0px;}